export enum ScheduledMessageTypeEnum {
  Scheduled = 'SCHEDULED',
  Suggested = 'SUGGESTED',
}
